import React, { useRef } from 'react';
import { NoResults } from '~/features/productsList/components';
import { M30ProductCarouselModule as M30ProductCarouselProps } from '~/lib/data-contract';
import { CarouselHits } from './components';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import { AlgoliaClientSearch } from '~/features/productsList/components';
import { useAlgoliaConfig } from '~/shared/hooks/useAlgoliaConfig';
import { config } from '../../constants';
import { useInView } from 'framer-motion';

export const M30ProductCarousel = ({
    maxNumberItems = 24,
    category,
    context,
    ...rest
}: M30ProductCarouselProps) => {
    const ref = useRef(null);
    const { key, token } = useAlgoliaConfig();
    const isInView = useInView(ref, config.intersectionObserverOptions);

    return (
        <div ref={ref}>
            {isInView ? (
                <ModuleContainer {...rest}>
                    <AlgoliaClientSearch
                        hitsPerPage={maxNumberItems ?? config.maxNumberItemsDefault}
                        algoliaApp={key}
                        algoliaToken={token}
                        category={category}
                        context={context}
                        shouldControlUrl={false}
                    >
                        <NoResults type="carousel">
                            <CarouselHits />
                        </NoResults>
                    </AlgoliaClientSearch>
                </ModuleContainer>
            ) : null}
        </div>
    );
};
